// extracted by mini-css-extract-plugin
export default {"container":"bN-z","dimension":"cN-z","dimensionLabels":"dN-z"};